import { DualAxes } from '@ant-design/charts';
import React from 'react';
import { statisticsDataKeys } from '../../../layouts/analytics/Analytics';
import moment from 'moment';
import '../Chart.scss';

function CustomDualAxesChart(props) {
  const {
    data = [],
    title = null,
    xAxis = 'Date',
    yAxis1 = null,
    yAxis2 = null,
    yAxis3 = null,
    currency = null,
  } = props;

  const config = {
    xField: xAxis,
    data: data,
    axis: {
      x: {
        labelFormatter: (value) =>
          xAxis?.toUpperCase() === 'DATE'
            ? moment(value)?.format(statisticsDataKeys.dateMonthFormat)
            : value,
      },
    },
    interaction: {
      tooltip: {
        sort: (d) => [yAxis1, yAxis2, yAxis3]?.indexOf(d?.name),
        render: (e, { title, items }) => {
          return (
            <div key={title}>
              <div
                style={{
                  color: '#a6a6a6',
                }}
              >
                {title}
              </div>
              {items?.map((item) => {
                const { name, value, color } = item;
                let showCurrency = false;
                if (
                  name === statisticsDataKeys?.orderAmount ||
                  name === statisticsDataKeys?.treatmentAmount ||
                  name === statisticsDataKeys?.requestAmount
                ) {
                  showCurrency = true;
                }
                return (
                  <div>
                    <div style={{ margin: 0, display: 'flex', justifyContent: 'space-between' }}>
                      <div
                        style={{
                          marginRight: 30,
                        }}
                      >
                        <span
                          style={{
                            display: 'inline-block',
                            width: 8,
                            height: 8,
                            borderRadius: '50%',
                            backgroundColor: color,
                            marginRight: 6,
                          }}
                        ></span>
                        <span>{name}</span>
                      </div>
                      <div
                        style={{
                          color: '#1a1a1a',
                        }}
                      >
                        {value} {showCurrency && currency}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        },
      },
    },
    scale: {
      color: {
        range: ['#06D6A0', '#FFD700', '#ca03fc'],
      },
    },
    legend: {
      color: {
        layout: {
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        },
      },
    },
    children:
      yAxis3 !== null
        ? [
            {
              data: data?.map((item) => {
                return {
                  Date: item[xAxis],
                  value: item[yAxis1],
                  type: yAxis1,
                };
              }),
              type: 'interval',
              yField: 'value',
              colorField: 'type',
              stack: true,
              style: { maxWidth: 80 },
              // Temporarily hide the value that appears on the bar.
              // label: {
              //   text: (d) => d["value"],
              //   textBaseline: "bottom",
              // },
              scale: {
                y: {
                  domainMax:
                    Number(
                      data?.reduce((max, obj) => (obj[yAxis1] > max ? obj[yAxis1] : max), 0) || 0,
                    ) + 20,
                  domainMin: 0,
                },
              },
              interaction: { elementHighlightByColor: { background: true } },
            },
            {
              data: [
                ...data.map((item) => ({
                  Date: item[xAxis],
                  count: item[yAxis2],
                  name: yAxis2,
                })),
                ...(yAxis3 !== null
                  ? data.map((item) => ({
                      Date: item[xAxis],
                      count: item[yAxis3],
                      name: yAxis3,
                    }))
                  : []),
              ],
              type: 'line',
              yField: 'count',
              colorField: 'name',
              axis: { y: { position: 'right' } },
              interaction: {
                tooltip: {
                  crosshairs: false,
                  marker: false,
                },
              },
              style: {
                lineWidth: 2,
              },
              scale: {
                y: {
                  domainMax:
                    Number(
                      data?.reduce((max, obj) => (obj[yAxis2] > max ? obj[yAxis2] : max), 0) || 0,
                    ) + 20,
                  domainMin: 0,
                },
              },
            },
          ]
        : [
            {
              type: 'interval',
              yField: yAxis1,
              style: { maxWidth: 40 },
              axis: { y: { position: 'left' } },
              // Temporarily hide the value that appears on the bar.
              // label: {
              //   text: (d) => d[yAxis1],
              //   textBaseline: "bottom",
              // },
              scale: {
                y: {
                  domainMax:
                    Number(
                      data?.reduce((max, obj) => (obj[yAxis1] > max ? obj[yAxis1] : max), 0) || 0,
                    ) + 20,
                  domainMin: 0,
                },
              },
            },
            {
              type: 'line',
              yField: yAxis2,
              style: {
                lineWidth: 2,
              },
              axis: { y: { position: 'right' } },
              scale: {
                y: {
                  domainMax:
                    Number(
                      data?.reduce((max, obj) => (obj[yAxis2] > max ? obj[yAxis2] : max), 0) || 0,
                    ) + 20,
                  domainMin: 0,
                },
              },
            },
          ],
  };
  return (
    <div className='col-12 mw-100 mh-100 h-100 d-flex flex-column pb-1'>
      {title !== null && (
        <div className='analytic-header-wrapper'>
          <span className='analytic-title'>{title}</span>
        </div>
      )}
      <div className='analytic-breaker' />
      <div className='axis-color d-flex justify-content-between px-4 pt-3'>
        <span style={{ background: '#06D6A0' }}></span>
        <div className='d-flex gap-1'>
          <span style={{ background: '#FFD700' }}></span>
          {yAxis3 !== null && <span style={{ background: '#ca03fc' }}></span>}
        </div>
      </div>
      <div className='chart-height mw-100'>
        <div className='h-100 w-100 mw-100 mh-100 px-1'>
          <DualAxes {...config} />
        </div>
      </div>
    </div>
  );
}

export default CustomDualAxesChart;
